import { render } from "./dialog_modal.vue?vue&type=template&id=67e5b6cf"
import script from "./dialog_modal.js?vue&type=script&lang=js"
export * from "./dialog_modal.js?vue&type=script&lang=js"

import "./dialog_modal.vue?vue&type=style&index=0&id=67e5b6cf&lang=scss"

import exportComponent from "M:\\Viridian Patriots\\Server\\pleroma-fe\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__